export const getImageUrl = (url: string) =>
    getIsLocalUrl(url) || url.startsWith("/api") ? url : `/api/image-proxy?imageUrl=${url}`;

export const getIsLocalUrl = (url: string) => url.startsWith("/") || url.startsWith("blob:") || url.startsWith("data:");
